import React from "react";

export default function CopyStep1() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          1
        </div>
        <h1 className="font-semibold text-lg">
          O primeiro passo é criar a conta de investidor gratuitamente.
        </h1>
      </div>
      <div className="pl-[42px] flex flex-col gap-1.5">
        <p>
          Somente com essa conta você poderá aderir à estratégia automatizada da
          MAIA™ e investir de forma automática com nossa IA.
        </p>
        <p>
          Para isso, abra o menu no app da XM e <b>clique em "A minha conta"</b>
          .
        </p>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/NuJahK0720161.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
